import React, { useEffect, useLayoutEffect, useState } from 'react';
import './stepperform.scss';
import { useLocation, useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/config/store';
import { setFormStep } from '../../../entities/case-forms/case-forms.reducer';

const Stepperform = () => {
  const [formstep, setSteps] = useState(1);
  const { id } = useAppSelector(state => state.authentication?.account);
  const getStep: any = localStorage.getItem('step');
  const retrievedArray: any = localStorage.getItem('submittedstep');
  const submitted = retrievedArray ?? JSON.parse(retrievedArray);
  const clickStep = getStep ?? JSON.parse(getStep);
  const { entities, loading, step } = useAppSelector(state => state.caseForm);
  const [formSubmitted, setFormSubmitted] = useState<any>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!id) return;

    const submittedRaw = localStorage.getItem('submittedstep');
    const submittedParsed = submittedRaw ? JSON.parse(submittedRaw) : {};
    const userSteps = submittedParsed[id] || [];

    setFormSubmitted(userSteps);
    if (clickStep) setSteps(clickStep);
  }, [id]);

  const steps = [
    { id: 1, label: 'Initial Screening Questions', path: '/step-1' },
    { id: 2, label: "Lawyer's Questions Screen", path: '/step-2' },
    { id: 3, label: 'Evidence Documenter Screen', path: '/evidence' },
    { id: 4, label: 'Review Case Report', path: '/report' },
  ];
  const handleClickSteps = (stepId: number) => {
    const selectedStep: any = steps.find(item => item.id === stepId);
    const isSubmitted = formSubmitted.includes(stepId);

    if (isSubmitted) {
      navigate(selectedStep?.path);
    }
  };

  // const handleClickSteps = stepId => {
  //   const selectedStep: any = steps.find(item => item.id == stepId);
  //   const storedStep = formSubmitted !== undefined ? JSON.parse(formSubmitted)?.includes(stepId) : false;
  //   const activeStep = formSubmitted !== undefined ? JSON.parse(formSubmitted)?.includes(formstep) : false;
  //   if (storedStep || activeStep) {
  //     navigate(selectedStep?.path);
  //   }
  // };

  return (
    <div className="steps-container mb-3 mb-lg-4">
      <div className="steps-progress d-flex ">
        {steps.map((step, index) => {
          const isActive = location.pathname === step.path;
          const isSubmitted = formSubmitted?.includes(step.id);

          return (
            <div
              key={step.id}
              className={`step-item ${isActive ? 'active' : ''} d-flex align-items-center ${isSubmitted ? 'clickable' : 'disabled'}`}
              onClick={() => handleClickSteps(step.id)}
              style={{ cursor: isSubmitted ? 'pointer' : 'not-allowed' }}
            >
              <div className={`step-circle ${isActive ? 'filled' : ''} ${isSubmitted ? 'submitted' : ''}`}>{step.id}</div>
              <span className="step-label">{step.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Stepperform;
